<div class="suif-body-copy-small">You've been inactive for a while. For your security, we'll automatically sign you out in approximately <span class="time-until-logout">{{formattedTimeUntilLogout}}</span>.</div>

<div class="suif-body-copy-small">Select "Stay Signed In" to continue working, or "Sign Out" if you're done.</div>

<div class="button-row">
    <button type="button" class="btn btn-secondary" (click)="logout()">Sign Out</button>
    <app-wait-button (onClick)="resetSession()" label="Stay Signed In"></app-wait-button>
</div>
